import React from 'react'
import PropTypes from 'prop-types'

function OverviewInvestmentObjective({ investorFundDetail }) {
  // remove this hack once off legacy UCM
  const strippedHtml = investorFundDetail
    .replace(/<span style=".*?>/, '')
    .replace('</span>', '')
    .replace(/\sclass=".*?(?=>)/, '')
    .replace('</p> <p>', '</p><br><p>')

  return (
    <div
      id="investment-objective"
      className="Grid u-paddingBottom6gu u-size12of12 u-marginBottom6gu"
    >
      <h3 className="u-marginBottom4gu">Investment Objective</h3>
      <span dangerouslySetInnerHTML={{ __html: strippedHtml }} />
    </div>
  )
}

OverviewInvestmentObjective.propTypes = {
  investorFundDetail: PropTypes.string.isRequired,
}
export default OverviewInvestmentObjective
